/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PROAUTH", "542")
  

// 接口文档

  
    
export interface IAPI75738ResDataItemTaskExcelImportV2FormObj {
  
  /** 表头 ,String */
  heads: string[];
  
  /** 表数据 ,Map */
  values: any[];
  
  /** 模型名称 */
  modelName?: string;
  
  /** 业务id */
  dataId?: string;
  
  /** 模型描述 */
  modelResponsibility?: string;
  
};
    
  
    
export interface IAPI75738ResDataItem {
  
  /** 主键 */
  id?: number;
  
  /** 数据唯一id */
  dataId?: string;
  
  /** 数据版本：V1、V2 */
  versionDesc?: string;
  
  /** 版本号 */
  version?: number;
  
  /** 内容-json */
  content?: string;
  
  /** 发布状态 */
  publishDesc?: string;
  
  /** 用户编号 */
  userId?: string;
  
  /** 创建人 */
  creator?: string;
  
  /** 修改人 */
  updater?: string;
  
  /** 创建时间 */
  createdAt?: string;
  
  /** 模型详情转换 ,TaskExcelImportV2Form */
  taskExcelImportV2Form?: IAPI75738ResDataItemTaskExcelImportV2FormObj;
  
};
    
  



export interface API75738Req {
  
  /** 数据唯一id */
  dataId?: string;
};



export type API75738Res = IAPI75738ResDataItem[];


// 接口函数 75738 查询数据模型详情

export interface IUsePostAPI75738Return {
  /** 查询数据模型详情: 接口请求状态 */
  isAPI75738Loading: boolean;
  /** 查询数据模型详情: 接口请求返回数据 */
  dataAPI75738: API75738Res;
  /**  查询数据模型详情: 接口数据请求方法 */
  fetchAPI75738Data: (inputs: API75738Req, config?: YWRequestConfig) => Promise<API75738Res>;
  /** 查询数据模型详情: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75738 = ():IUsePostAPI75738Return => {
  let isMount = true;
  const [isAPI75738Loading, setIsAPI75738Loading] = useState(false);
  const [dataAPI75738, setDataAPI75738] = useState<API75738Res>({} as API75738Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/get/detail`;

  const fetchAPI75738Data = async (inputs: API75738Req, config?: YWRequestConfig): Promise<API75738Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75738Req>) || {}) as API75738Req;
    
  
    if ( isMount ) {
      setIsAPI75738Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75738Res>(`${basePath}/yoaichat-web/chat/task/model/get/detail`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75738(res || {} as API75738Res);
        setIsAPI75738Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75738Loading(false);
      }
      return false as unknown as API75738Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75738Loading,
    dataAPI75738,
    fetchAPI75738Data,
    requestUrl,
  }
}

